import * as React from "react";
import { format } from "date-fns";
import { Calendar as CalendarIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useIsMobile } from "@/hooks/use-mobile";
import { cn } from "@/lib/utils";

interface DatePickerWithRangeProps {
  className?: string;
  date: {
    from: Date;
    to: Date;
  };
  setDate: React.Dispatch<React.SetStateAction<{ from: Date; to: Date }>>;
}

export function DateRangePicker({ className, date, setDate }: DatePickerWithRangeProps) {
  const isMobile = useIsMobile();

  return (
    <div className={cn("grid gap-2", className)}>
      <Popover>
        <PopoverTrigger asChild>
          <Button
            id="date"
            variant={"outline"}
            className={cn("w-full justify-start text-left font-normal", !date && "text-muted-foreground")}
          >
            <CalendarIcon className="mr-2 h-4 w-4" />
            {date?.from ? (
              date.to ? (
                <>
                  {format(date.from, "LLL dd, y")} - {format(date.to, "LLL dd, y")}
                </>
              ) : (
                format(date.from, "LLL dd, y")
              )
            ) : (
              <span>Pick a date</span>
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar
            initialFocus
            fromDate={new Date("2022-11-16")}
            toDate={new Date()}
            mode="range"
            defaultMonth={date?.to}
            selected={{ from: date.from, to: date.to }}
            onSelect={(selectedDate) => {
              if (selectedDate?.from) {
                setDate((prev) => ({ ...prev, from: selectedDate.from ?? prev.from }));
              }
              if (selectedDate?.to) {
                setDate((prev) => ({ ...prev, to: selectedDate.to ?? prev.to }));
              }
            }}
            numberOfMonths={isMobile ? 1 : 2}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
}
